import { $http } from "@/plugins/api";
import { Commit } from "vuex";

export type Pill = { variant: string; text: string };
export type Info = { docsLink: string; text: string };

export type PageMeta = {
  title: string;
  icon?: string;
  pill?: Pill;
  info?: Info;
  mspName: string;
  customerName: string;
  parentPath: string;
};

export type TitleOptions = Pick<PageMeta, "title" | "icon" | "pill" | "info">;

const state: PageMeta = {
  title: "",
  icon: undefined,
  pill: undefined,
  info: undefined,
  mspName: "msp",
  customerName: "customer",
  parentPath: "",
};

const getters = {
  pageMeta: (state: PageMeta) => state,
};

const actions = {
  setPageTitle({ commit }: { commit: Commit }, options: TitleOptions) {
    const { title, icon, pill, info } = options;

    document.title = title;
    commit("setPagePill", pill ?? null);
    commit("setPageInfo", info ?? null);
    commit("setPageTitle", title);
    commit("setPageIcon", icon ?? null);
  },
  async getOrginisationsList(
    { commit }: { commit: Commit },
    { parent_uuid }: { parent_uuid: string },
  ) {
    const url = parent_uuid
      ? `/organisations?parent_uuid=${parent_uuid}`
      : `/organisations`;
    const orgsResponse = await $http.get(url);

    commit("addDropDown", orgsResponse.data.data);
  },
  setParentPath({ commit }: { commit: Commit }, path: string) {
    commit("setParentPath", path);
  },
  setMSP({ commit }: { commit: Commit }, name: string) {
    commit("setMSP", name);
  },
  setCustomerName({ commit }: { commit: Commit }, name: string) {
    commit("setCustomer", name);
  },
};

const mutations = {
  setPageTitle: (state: PageMeta, title: string) => (state.title = title),
  setPageIcon: (state: PageMeta, icon: string) => (state.icon = icon),
  setPagePill: (state: PageMeta, pill: Pill) => (state.pill = pill),
  setPageInfo: (state: PageMeta, info: Info) => (state.info = info),
  setMSP: (state: PageMeta, name: string) => (state.mspName = name),
  setCustomer: (state: PageMeta, name: string) => (state.customerName = name),
  setParentPath: (state: PageMeta, path: string) => (state.parentPath = path),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
